import _ from 'lodash';

export function mergeArray(firstArray: any[], secondArray: any[], uniqueId?: string | number): any[] {
  if(!uniqueId) return _.union((firstArray || []), (secondArray || []));
  return _.unionBy((firstArray || []), (secondArray || []), uniqueId);
}